import { WorkflowNode, WorkflowEdge } from '../../store/workflow/types';

// sanitizeNode 함수
export function sanitizeNode(node: Partial<WorkflowNode>): WorkflowNode {
  return {
    id: node.id || '',
    type: node.type || '',
    position: { ...(node.position || { x: 0, y: 0 }) },
    data: node.data ? JSON.parse(JSON.stringify(node.data)) : {},
    width: node.width ? Number(node.width) : undefined,
    height: node.height ? Number(node.height) : undefined,
    selected: node.selected,
    draggable: node.draggable,
    selectable: node.selectable
  } as WorkflowNode;
}

// sanitizeEdge 함수
export function sanitizeEdge(edge: Partial<WorkflowEdge>): WorkflowEdge {
  return {
    id: edge.id || '',
    source: edge.source || '',
    target: edge.target || '',
    type: edge.type,
    data: edge.data ? JSON.parse(JSON.stringify(edge.data)) : undefined,
    label: edge.label
  } as WorkflowEdge;
}

// 그룹 노드 타입인지 확인하는 헬퍼 함수
export function isGroupNodeType(type: string): boolean {
  return type === 'group' || type === 'subflow' || type === 'repeatGroup';
} 